import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorMessage } from '../utils/errorHandlers';

/**
 * Global middleware to catch RTK Query errors and display toasts.
 * Especially useful for 429 (Rate Limit) and 500 (Server Error).
 */
export const errorToastMiddleware: Middleware = () => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        const error = action.payload;
        const status = error?.status;

        // Customize toast behavior based on status
        if (status === 429) {
            toast.error('Slow down! You are making too many requests.', {
                id: 'rate-limit-toast', // Prevent duplicate toasts
                duration: 4000,
            });
        } else if (status === 500) {
            toast.error('Server error. Please try again later.');
        } else if (status === 'FETCH_ERROR') {
            toast.error('Check your internet connection.');
        } else {
            // For other errors, we might want to be more selective to avoid spamming
            // but getErrorMessage helps provide context
            const message = getErrorMessage(error);
            if (status && status !== 401 && status !== 400) {
                toast.error(message);
            }
        }
    }

    return next(action);
};
